// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'nouislider/distribute/nouislider.css'
import 'onsenui/css/onsenui.css'
import { global } from './global.js'
import './assets/app.css'
import Vue from 'vue'
import VueOnsen from 'vue-onsenui'
import App from './App'

// switch (global.THEME) {
//   case '1':
//     require('./assets/css/theme1/onsen-css-components.css');
//     require('./assets/css/theme1/theme.css');
//     break;
//   case '2':
//     require('./assets/css/theme2/onsen-css-components.css');
//     require('./assets/css/theme2/theme.css');
//     break;
//   case '3':
//     require('./assets/css/theme3/onsen-css-components.css');
//     require('./assets/css/theme3/theme.css');
//     break;
// }
import './assets/css/theme3/onsen-css-components.css'
import './assets/css/theme3/theme.css'

Vue.config.productionTip = false

Vue.use(VueOnsen)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  template: '<App/>',
  components: { App },
  beforeCreate() {
    this.$ons.disableAutoStyling();
  }
});



// WEBPACK FOOTER //
// ./src/main.js